import { ColumnDef } from "@tanstack/react-table";
import { SpiffRuleEvent } from "@/spiff-rules/spiff-rule";
import { SpiffEventBadge } from "@/spiffs/common/spiff-event-badge";

interface WithTriggerEvent {
  trigger_event: SpiffRuleEvent;
}

const SpiffTypeCol = <T extends WithTriggerEvent>(): ColumnDef<T> => ({
  header: "Type",
  meta: { size: "175px" },
  accessorFn: (row) => row.trigger_event,
  cell: ({ row }) => (
    <SpiffEventBadge triggerEvent={row.original.trigger_event} />
  ),
});

export default SpiffTypeCol;
